// extracted by mini-css-extract-plugin
export var dropdownIcon = "_oz-6";
export var imgContainer = "_oz-3";
export var menuIcon = "_oz-5";
export var pillWrapper = "_oz-2";
export var pillsContainer = "_oz-1";
export var subscriptionCard = "_oz-0";
export var subscriptionLogo = "_oz-4";